(ns frontend.view.settings.sys-admin.tenant.sessions.view
  (:require
   [common.localization :as loc]
   [common.dates :as dt]
   [common.time :refer [rfc-3339-pattern]]
   [frontend.view.settings.sys-admin.db :as db]
  ))

(def headers
  [:tenant-sessions/first-name
   :tenant-sessions/last-name
   :tenant-sessions/email
   :tenant-sessions/login
   :tenant-sessions/duration
   :tenant-sessions/device-type
   :tenant-sessions/device-id])

(defn table-header
  [header]
  [:th (loc/tr header)])

(defn first-zero
  [v]
  (if (< v 10) (str "0" v) v))

(defn formatted
  [duration]
  (let [hours (quot duration 3600000)
        minutes (quot duration 60000)]
    (str (first-zero hours) ":" (first-zero minutes))))

(defn table-row
  [{:tenant-sessions/keys [first-name last-name email login duration device-type device-id]}]
  [:tr
   {:class "*:whitespace-nowrap *:px-2 *:py-3 *:text-sm *:text-base-light-text even:bg-base-regular"}
   [:td first-name]
   [:td last-name]
   [:td email]
   [:td
    (if-not login
      ""
      (-> (dt/date-time login {:pattern rfc-3339-pattern})
          (dt/format {:pattern (loc/tr :date-time-format)})))]
   [:td
    (if-not (number? duration)
      ""
      (formatted duration))]
   [:td device-type]
   [:td device-id]])

(defn header-key
  [v]
  (str "tenant-sessions-table-header-" (name v)))

(defn table-row-key
  [{:tenant-sessions/keys [account-id duration created]}]
  (str "tenant-sessions-table-item-" account-id "-" duration "-" created))

(defn render
  [tenant]
  (let [data (->> @db/cached-reports
                  (filter (fn [cr]
                            (= (:cached-report/report-key cr) :cached-report.type/tenant-sessions)))
                  (sort-by :common/updated-on)
                  (last)
                  :cached-report/value)]
    [:div
     {:class "border border-solid border-base-light-border-paler rounded"}
     [:div 
      {:class "p-3 flex justify-between items-center border-b border-solid border-base-light-border-paler"}
      [:h2
       {:class "font-bold"}
       (loc/tr :tenant-sessions/card-header)]]
     [:div
      {:class "p-4 w-full"}
      [:table
       {:class-name "min-w-full divide-y divide-solid divide-base-regular-border-paler"}
       [:thead
        [:tr
         {:class "*:py-3 *:px-2 *:text-left *:text-sm *:font-bold *:text-base-light-text"}
         (for [item headers]
           ^{:key (header-key item)}
           [table-header item])]]
       [:tbody
        (for [item data]
          ^{:key (table-row-key item)}
          [table-row item])]]]]))
